import React from 'react';

import './style.scss';

const Content = props => {
  const { children } = props;

  return (<div className="main-content container-fluid">
    {children}
  </div>)
};

export default Content;